import {StyleSheet} from 'react-native';

import {yellow, yellowLighter} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 16,
  },
  progressBarBase: {
    backgroundColor: yellowLighter,
  },
  progressBarFill: {
    backgroundColor: yellow,
  },
  text: {
    marginTop: 10,
  },
});
